import {
  InputTypes,
  SelectInputPart,
  StringTemplatePart,
  TemplatePart
} from "./types";

export function isSelectInput(value: any): value is SelectInputPart {
  return value?.inputType === InputTypes.SELECT;
}

export function isStringTemplatePart(
  part: TemplatePart
): part is StringTemplatePart {
  return ["markdown", "text", "latex"].includes(part.type);
}
